export function getConversationAvatarTone(chat, { selected = false } = {}) {
  const userListTokens = chat?.userList || {};

  return {
    background: userListTokens.avatarBackground || '#EEF2F6',
    foreground: userListTokens.avatarColor || chat?.textPrimary,
  };
}
